module.exports = __webpack_public_path__ + "static/img/PK4.c23d7d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK4.jpg
// module id = V9BJ
// module chunks = 0